// Deterministic hash-to-color for campaign visual identity.
// 8 distinct hues tuned for readability on the dark #0d0d1a modal background.
// Same color is used consistently for chip dots, bar segments, and table markers.

const CAMPAIGN_PALETTE = [
  '#b490ff', // violet (matches existing edv-tab--active accent)
  '#4fc3f7', // sky blue
  '#81c784', // sage green
  '#ffb74d', // amber
  '#f06292', // rose
  '#4dd0e1', // teal
  '#aed581', // lime
  '#ff8a65', // coral
] as const

/** Deterministic djb2-style hash of a string → 0..N-1 */
function hashStringToIndex(s: string, n: number): number {
  let hash = 5381
  for (let i = 0; i < s.length; i++) {
    hash = ((hash << 5) + hash) ^ s.charCodeAt(i)
    hash = hash >>> 0
  }
  return hash % n
}

/** Returns a hex color for a campaignId, consistent across renders. */
export function campaignColor(campaignId: string): string {
  const idx = hashStringToIndex(campaignId, CAMPAIGN_PALETTE.length)
  return CAMPAIGN_PALETTE[idx]!
}
